module.exports = __webpack_public_path__ + "img/图1-14角度的尺寸注法.eb09718e.jpg";